import { FormattedMessage } from "react-intl";
import LabelLang, { LabelLangString } from "component/LabelLang/label-lang.js";

export default function SubscribeSelectField({
  register,
  name,
  labelId,
  dir,
  currentLocale,
  options,
  optionValueKey = "id",
  optionLabelKey = "name",
  optionTranslationsKey = "Translation",
  labelTranslationId = "name",
}) {
  return (
    <div className="form-label row">
      <div className="col-xl-4 col-lg-3">
        <label>
          <FormattedMessage id={labelId} />:
        </label>
      </div>
      <div className="col-xl-8 col-lg-9">
        <div className="form-label-container dropdown">
          <select
            className={`${dir === "rtl" ? "r-dir" : "l-dir"}`}
            {...register(name)}
          >
            {options.map((option, i) => (
              <option
                key={i}
                value={option[optionValueKey]}
                title={LabelLangString({
                  id: labelTranslationId,
                  currentLocale,
                  defaultValue: option[optionLabelKey],
                  translations: option[optionTranslationsKey],
                })}
              >
                <LabelLang
                  id={labelTranslationId}
                  defaultValue={option[optionLabelKey]}
                  translations={option[optionTranslationsKey]}
                />
              </option>
            ))}
          </select>
          <span>*</span>
        </div>
      </div>
    </div>
  );
}
